exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_headerColumnFixedWidth__2y2mZ{width:9.375rem}.style_headerColumnOccurredDate__11k3c{width:9.375rem;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"headerColumnFixedWidth": "style_headerColumnFixedWidth__2y2mZ",
	"headerColumnOccurredDate": "style_headerColumnOccurredDate__11k3c"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/EventListing/style.less
// module id = 1796
// module chunks = 8